var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AdvancedScrollList',{staticClass:"mt-4",attrs:{"items":_vm.listItems,"loading":_vm.isFetching},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(item[_vm.$props.rlsGroup] || item[_vm.$props.rlsGroup.toLowerCase()])+"\n  ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }